"use strict";
// ================================================================
// v2/tokens/typography.ts
// モード非依存のタイポグラフィトークン。
// 色は含めない (色は theme.palette.v2.foreground から適用すること)。
//
// Figma 変数対応表 (App-Design):
//   ── fontWeight ──          ── textStyles ──
//   regular  ⇄ W3 (300)       pageTitle    ⇄ JP/H2        (24/32/700/-0.1)
//   normal   ⇄ W4 (400)       sectionTitle ⇄ JP/H3        (20/28/600/-0.1)
//   medium   ⇄ W5 (500)       countdown    ⇄ JP/Subtitle1 (14/20/600/-0.05)
//   semiBold ⇄ W6 (600)       cardTitle    ⇄ JP/Subtitle2 (12/16/600/0)
//   bold     ⇄ W7 (700)       label        ⇄ JP/Subtitle2 (12/16/600/0)
//                             cardMeta     ⇄ JP/Overline  (10/14/600/0)
//                             body         ⇄ JP/Body2     (14/20/300/-0.05)
//                             caption      ⇄ JP/Caption   (12/16/400/0)
// ================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyles = exports.lineHeight = exports.fontSize = exports.fontWeight = exports.fontFamily = void 0;
exports.fontFamily = {
    /** 日本語プライマリ (Hiragino Kaku Gothic Pro W6/W3) */
    ja: '"Hiragino Kaku Gothic Pro", "Hiragino Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    /** 英数字・補助 (Inter / Noto Sans / SF Pro) */
    en: '"Inter", "Noto Sans", "SF Pro", sans-serif',
};
exports.fontWeight = {
    /** W3 = 300 — 本文のデフォルト (Hiragino W3) */
    regular: 300,
    /** W4 = 400 — キャプション JP/Caption (Hiragino W4) */
    normal: 400,
    /** W5 = 500 */
    medium: 500,
    /** W6 = 600 — 見出し・ボタン (Hiragino W6) */
    semiBold: 600,
    /** W7 = 700 — 大見出し JP/H2 (Hiragino W7) */
    bold: 700,
};
/** px 値 (number)。Figma フォントサイズ 10/12/14/16/20/24 に対応。 */
exports.fontSize = {
    '2xs': 10,
    xs: 12,
    sm: 14,
    base: 16,
    lg: 20,
    xl: 24,
};
/** px 値 (number)。Figma 行間 14/16/20/22/24/28/32 に対応。 */
exports.lineHeight = {
    '2xs': 14,
    xs: 16,
    sm: 20,
    /** 22px — JP/H4 (16px 見出し) 専用の行間 */
    md: 22,
    base: 24,
    lg: 28,
    xl: 32,
};
/**
 * よく使う組み合わせ。color は含まないので、利用側で
 * theme.palette.v2.foreground.* を併用する。
 */
exports.textStyles = {
    /** JP/H2 (24 / 32 / W7 / -0.1) */
    pageTitle: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.xl,
        lineHeight: "".concat(exports.lineHeight.xl, "px"),
        fontWeight: exports.fontWeight.bold,
        letterSpacing: -0.1,
    },
    /** JP/H3 (20 / 28 / W6 / -0.1) */
    sectionTitle: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.lg,
        lineHeight: "".concat(exports.lineHeight.lg, "px"),
        fontWeight: exports.fontWeight.semiBold,
        letterSpacing: -0.1,
    },
    /** JP/H4 (16 / 22 / W6 / -0.1) — 画面内のサブセクション見出し */
    subsectionTitle: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.base,
        lineHeight: exports.lineHeight.md,
        fontWeight: exports.fontWeight.semiBold,
        letterSpacing: -0.1,
    },
    /**
     * JP/Subtitle1 (14 / 20 / W6 / -0.05)
     * 強調した 14px テキスト全般 (ボタンラベル・カード内の見出し行など)。
     */
    subtitle: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.sm,
        lineHeight: exports.lineHeight.sm,
        fontWeight: exports.fontWeight.semiBold,
        letterSpacing: -0.05,
    },
    /** JP/Subtitle2 (12 / 16 / W6 / 0) */
    cardTitle: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.xs,
        lineHeight: "".concat(exports.lineHeight.xs, "px"),
        fontWeight: exports.fontWeight.semiBold,
    },
    /** JP/Overline (10 / 14 / W6 / 0) — キャプションではなくオーバーライン */
    cardMeta: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize['2xs'],
        lineHeight: "".concat(exports.lineHeight['2xs'], "px"),
        fontWeight: exports.fontWeight.semiBold,
    },
    /** JP/Body2 (14 / 20 / W3 / -0.05) */
    body: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.sm,
        lineHeight: "".concat(exports.lineHeight.sm, "px"),
        fontWeight: exports.fontWeight.regular,
        letterSpacing: -0.05,
    },
    /** JP/Subtitle1 (14 / 20 / W6 / -0.05) */
    countdown: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.sm,
        lineHeight: "".concat(exports.lineHeight.sm, "px"),
        fontWeight: exports.fontWeight.semiBold,
        letterSpacing: -0.05,
    },
    /** JP/Subtitle2 (12 / 16 / W6 / 0) */
    label: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.xs,
        lineHeight: "".concat(exports.lineHeight.xs, "px"),
        fontWeight: exports.fontWeight.semiBold,
    },
    /** JP/Caption (12 / 16 / W4 / 0) */
    caption: {
        fontFamily: exports.fontFamily.ja,
        fontSize: exports.fontSize.xs,
        lineHeight: "".concat(exports.lineHeight.xs, "px"),
        fontWeight: exports.fontWeight.normal,
    },
};
